// src\themes\tolica\elements\Header\MainContentWrapper.tsx
'use client';

import { ReactNode } from 'react';
import { useIsHome } from '@/core/hooks/use-is-home';
import { cn } from '@/core/lib/utils';

type MainContentWrapperProps = {
    children: ReactNode;
};

export default function MainContentWrapper({ children }: MainContentWrapperProps) {
    const isHome = useIsHome();

    // هدر الان fixed هست (برای این‌که بشه شفافش کرد)، پس دیگه خودش فضا نمی‌گیره.
    // توی صفحه‌ی اصلی می‌خوایم بنر زیر هدرِ شفاف بره (بدون فاصله)، ولی بقیه‌ی
    // صفحات باید هم‌ارز فاصله‌ی قبلیِ هدرِ sticky (h-20) رو داشته باشن تا محتوا
    // زیر هدر پنهان نشه
    return (
        <div className={cn('min-h-full', !isHome && 'pt-20')}>
            {children}
        </div>
    );
}
